// Theme preference ("light" | "system" | "dark") -> .dark class on <html>.
export function applyTheme(pref) {
  const dark = pref === "dark" ||
    (pref === "system" && typeof window !== "undefined" &&
     window.matchMedia?.("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", !!dark);
}
